import React from 'react'
import { MetaTags } from '../meta-tags'

const CategoryMetaTags = ({ category }) => {
  const {
    name,
    description,
    metaTitle,
    metaDescription,
    metaTags,
    heroImage,
    sk,
    staticUrl
  } = category

  let { canonicalLink } = category
  canonicalLink = canonicalLink || `${window.location.origin}/${sk}/${staticUrl}`

  return (
    <MetaTags
      title={metaTitle ?? name}
      description={metaDescription ?? description}
      canonicalLink={canonicalLink}
      metaTags={metaTags}
      ogTags={{
        'og:type': 'website',
        'og:image': heroImage
      }}
    />
  )
}

export default CategoryMetaTags
